<template>
    <div>
        <div v-for="(item, index) in reg_statsionar" :key="index">
            <b-tabs active-nav-item-class="font-weight-bold text-light bg-info">
                <!-- <b-tab
                    :title="$t('Бемор')"
                    title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
                    style="padding: 0px !important;"
                >
                    <div class="tek-card">
                        
                        <div class="stat-bemor-text">
                            <div style="display: flex;">
                                <p>Шифохонага ётқизилган кун:</p>
                                <div>
                                    <date-picker
                                        style="width: 200px;"
                                        v-model="item.recede_day"
                                        format="DD.MM.YYYY HH:mm"
                                        value-type="X"
                                        type="datetime"
                                        :lang="lang"
                                    ></date-picker>
                                </div>
                            </div>
                            <div style="display: flex;">
                                <p>Шифохонадан чиқарилган кун:</p>
                                <div>
                                    <date-picker
                                        style="width: 200px;"
                                        v-model="item.arrive_day"
                                        format="DD.MM.YYYY HH:mm"
                                        value-type="X"
                                        type="datetime"
                                        :lang="lang"
                                    ></date-picker>
                                </div>
                            </div>
                            
                        </div>
                        
                    </div>
                </b-tab> -->
                <b-tab
                :title="$t('Текшириш')"
                title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
                style="padding: 0px !important;"
                >
                <div class="tek-card">
                    <StatDoctor
                        :reg_statsionar_doctor="item.reg_statsionar_doctor"
                    />
                </div>
                </b-tab>
                <b-tab
                    :title="$t('Кундалик')"
                    title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
                    style="padding: 0px !important;"
                >
                    <div class="tek-card">
                        <Kundalik 
                            :reg_statsionar_doctor="item.reg_statsionar_doctor"
                        />
                    </div>
                </b-tab>
                <b-tab
                    :title="$t('Даволош сўнги')"
                    title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
                    style="padding: 0px !important;"
                >
                    <div class="tek-card">
                        
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import StatDoctor from "./StatDoctor.vue";
import moment from 'moment';
import Kundalik from "./Kundalik.vue";
export default {
    props: ["reg_statsionar"],
    components: {
        DatePicker,
        StatDoctor,
        Kundalik
    },
    data(){
        return {
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1
                },
                monthBeforeYear: false
            },
        }
    },
    filters: {
        DateFormat: (date) => {
            console.log(date);
            if (date) {
                return moment.unix(date).format("DD MM YYYY HH:mm:ss");
            } else {
                return "";
            }
        },
    },
    methods: {
         
    }
}
</script>

<style>
.stat-bemor-text p{
    font-size: 18px;
    font-weight: 600;
    margin-right: 5px;
}
</style>